<template>
    <div class="pc-news" id="pc-news">
        <div class="header-wrap" id="header-wrap-id">
            <transition name="fade">
            <div class="nav" v-show="showNav">
                <ul>
                    <img class="menu-logo" src="https://www.xfz.cn/explore/xfz2019/static/img/logo.128ba78.png">
                    <li><a class="nav-link" target="_blank" href="/explore/xfz2019/#s-summary">首页</a></li>
                    <li><a class="nav-link" target="_blank" href="/explore/xfz2019/#s-guest">邀请嘉宾</a></li>
                    <li><a class="nav-link" target="_blank" href="/explore/xfz2019/#s-agenda">大会议程</a></li>
                    <li><a class="nav-link" target="_blank" href="/explore/xfz2019/#s-award">奖项评选</a></li>
                    <li><a class="nav-link" target="_blank" href="/explore/xfz2019/#s-tickets">参会购票</a></li>
                    <li><a class="nav-link" target="_blank" href="/explore/xfz2019/#s-partners">合作机构</a></li>
                    <li><a class="nav-link" target="_blank" href="/explore/xfz2019/#s-contact-us">联系我们</a></li>
                </ul>
            </div>
            </transition>
        </div>

        <!-- 大会直播 new -->
        <div class="section live">
            <div class="live-wrap">
                <div class="live-title">官方直播平台</div>
                <div class="live-items-wrap">
                    <div class="live-area">
                        <a class="live-item" href="https://m.yiketalks.com/html/liveEnrollDetail2.html?id=1241" target="_blank" style=" text-align: center;">
                            <img src="https://static-image.xfz.cn/1573721713130/一刻-fintech.partner">
                        </a>
                        <a class="live-item" href="https://live.photoplus.cn/live/54564923" target="_blank" style=" text-align: center;">
                            <img src="https://static-image.xfz.cn/1573726183073/谱时-fintech.partner">
                        </a>
                    </div>
                </div>
            </div>
            <div class="live-wrap">
                <div class="live-title">直播支持平台</div>
                <div class="live-items-wrap">
                    <div class="live-area">
                        <a v-for="item in liveLinks" class="live-item" :href="item.link" target="_blank">
                            <img :src="item.img">
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <!-- 大会直播 -->
        <div class="section live" v-if="false">
            <div class="live-wrap">
                <div class="live-title">大会直播</div>
                <div class="live-items-wrap">
                    <div class="live-area">
                        <div v-for="item in liveData[0]" class="live-item">
                            <div class="live-name"><a :href="item.links[0].link" target="_blank">{{item.title}}</a></div>
                            <div class="live-links">
                                <template v-if="item.links.length == 1">
                                    <div class="link-item"><a :href="item.links[0].link" target="_blank">{{ item.links[0].name }}</a></div>
                                </template>
                                <template v-if="item.links.length == 2">
                                    <div class="link-item"><a :href="item.links[0].link" target="_blank">{{ item.links[0].name }}</a></div>
                                    <div class="link-divider"> &nbsp;</div>
                                    <div class="link-item"><a :href="item.links[1].link" target="_blank">{{ item.links[1].name }}</a></div>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 课程引导 -->
        <div class="section course" v-if="false">
            <!-- 投资人眼中的消费升级 -->
            <div class="course-wrap">
                <div class="course-title">投资人眼中的消费升级</div>
                <div class="course-items-wrap">
                    <div class="course-area">
                        <div v-for="item in investorUpData" class="course-item">
                            <a :href="item.url" target="_blank">
                                <div class="info-logo">
                                    <img class="main" :src="item.img" alt="资本寒冬，创业公司如何快速获取融资">
                                    <span class="tags"></span>
                                </div>
                                <div class="info-content">
                                    <div class="course-item-title">{{ item.title }}</div>
                                    <div class="info-author">{{ item.name }} {{ item.position ? '/':'' }} {{ item.position }}</div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 新品牌、新零售、新场景 -->
            <div class="course-wrap">
                <div class="course-title">新品牌、新零售、新场景</div>
                <div class="course-items-wrap">
                    <div class="course-area">
                        <div v-for="item in useUpData" class="course-item">
                            <a :href="item.url" target="_blank">
                                <div class="info-logo">
                                    <img :src="item.img" alt="资本寒冬，创业公司如何快速获取融资">
                                    <span class="tags"></span>
                                </div>
                                <div class="info-content">
                                    <div class="course-item-title">{{ item.title }}</div>
                                    <div class="info-author">{{ item.name }} {{ item.position ? '/':'' }} {{ item.position }}</div>
                                </div>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="pc-news-list">
            <div class="news-list-wrap">
                <div class="title-area">
                    <div class="title">大会相关新闻</div>
                    <div class="refresh" @click="refreshContent()">
                        <img src="../assets/icon-refresh.png" alt=""> 刷新
                    </div>
                </div>
                <template  v-for="item in newsData">
                    <pc-news-item  :news="item"></pc-news-item>
                </template>
                <template v-if="newsData.length == 0">
                    <div style="width:200px; text-align:center; margin: 20px auto; font-size:22px;">暂无新闻</div>
                </template>
            </div>
        </div>
        <br><br><br><br><br><br>
    </div>
</template>

<script>
import PcNewsItem from './PcNewsItem.vue'
import util from '../assets/js/util'
import liveData from '../assets/js/livedata.js'

export default{
    components:{ PcNewsItem },
    data(){
        return{
            showNav: true,
            newsData: [],
            liveData: [],
            liveLinks: [
                // {   // 腾讯
                //     img: require('../assets/autumn/1_tengxun.png'),
                //     link: 'http://v.qq.com/live/p/topic/60284/preview.html'
                // },
                {
                    img: 'https://static-image.xfz.cn/1573722550136/云现场-fintech.partner',
                    link: 'http://www.yun-live.com/meeting/587'
                },
                {
                    img: 'https://static-image.xfz.cn/1573725094527/微吼-fintech.partner',
                    link: 'https://zhike.vhall.com/webinar/subscribe/97535488'
                },
                {
                    img: 'https://static-image.xfz.cn/1573722615936/盟主直播-fintech.partner',
                    link: 'http://z-mz.cn/MTvw'
                },
                {
                    img: 'https://static-image.xfz.cn/1573722333455/风岐茶社-fintech.partner',
                    link: 'http://www.phoenixtea.org/live/1468'
                },
            ],
            // 投资人眼中的消费升级
            investorUpData:[{
                img:"http://static-image.xfz.cn/1503036169_345.jpg-course.list.small",
                url:"http://www.xfz.cn/course/131.html",
                title:"消费新方圆——下一代的成功范式",
                name:"张鑫钊",
                position:"启承资本董事总经理"
            },{
                img:"http://static-image.xfz.cn/1503036079_897.jpg-course.list.small",
                url:"http://www.xfz.cn/course/134.html",
                title:"创业VS投资：反观消费升级的新价值",
                name:"周航",
                position:"顺为资本投资合伙人"
            },{
                img:"http://static-image.xfz.cn/1503382942_469.jpg-course.list.small",
                url:"http://www.xfz.cn/course/140.html",
                title:"互联网投资趋势下的消费升级",
                name:"郎春晖",
                position:"创新工场合伙人"
            },{
                img:"http://static-image.xfz.cn/1503397089_562.jpg-course.list.small",
                url:"http://www.xfz.cn/course/152.html",
                title:"消费升级创业的机会与投资",
                name:"投资大咖论",
                position:""
            }],
            // 消费升级明星创业案例
            useUpData: [{
                img:"http://static-image.xfz.cn/1503036256_116.jpg-course.list.small",
                url:"http://www.xfz.cn/course/129.html",
                title:"信用生态驱动的消费转型趋势",
                name:"李丛杉",
                position:"蚂蚁金服芝麻信用副总经理"
            },{
                img:"http://static-image.xfz.cn/1503036141_896.jpg-course.list.small",
                url:"http://www.xfz.cn/course/132.html",
                title:"莫善于乐——从“维纳斯计划”到迷你KTV",
                name:"马杰",
                position:"雷石CEO 、WOW屋创始人"
            },{
                img:"http://static-image.xfz.cn/1503036105_512.jpg-course.list.small",
                url:"http://www.xfz.cn/course/133.html",
                title:"新商业机会下的品类升级",
                name:"林依轮",
                position:"饭爷品牌创始人"
            },{
                img:"http://static-image.xfz.cn/1503036037_651.jpg-course.list.small",
                url:"http://www.xfz.cn/course/135.html",
                title:"生鲜新零售的终极布局",
                name:"徐正",
                position:"每日优鲜创始人兼CEO"
            },{
                img:"http://static-image.xfz.cn/1503036005_238.jpg-course.list.small",
                url:"http://www.xfz.cn/course/136.html",
                title:"消费升级背后的5个真相",
                name:"朱月怡",
                position:"花点时间创始人兼CEO"
            },{
                img:"http://static-image.xfz.cn/1503035974_824.jpg-course.list.small",
                url:"http://www.xfz.cn/course/137.html",
                title:"共享充电行业如何打赢持久战",
                name:"唐永波",
                position:"小电科技创始人兼CEO"
            },{
                img:"http://static-image.xfz.cn/1503035919_824.jpg-course.list.small",
                url:"http://www.xfz.cn/course/138.html",
                title:"一个新消费品的全渠道成长之路",
                name:"刘丹尼",
                position:"乐纯CEO"
            },{
                img:"http://static-image.xfz.cn/1503035847_516.jpg-course.list.small",
                url:"http://www.xfz.cn/course/141.html",
                title:"生活方式空间的场景打造",
                name:"但捷",
                position:"言几又董事长兼CEO"
            },{
                img:"http://static-image.xfz.cn/1503035815_532.jpg-course.list.small",
                url:"http://www.xfz.cn/course/142.html",
                title:"消费升级下的医美市场",
                name:"金星",
                position:"新氧创始人兼CEO"
            },{
                img:"http://static-image.xfz.cn/1503035794_864.jpg-course.list.small",
                url:"http://www.xfz.cn/course/143.html",
                title:"从需求迭代看中国房屋分享",
                name:"王连涛",
                position:"小猪联合创始人兼COO"
            },{
                img:"http://static-image.xfz.cn/1503282295_909.jpg-course.list.small",
                url:"http://www.xfz.cn/course/144.html",
                title:"体育运动产业的新零售与共享入口",
                name:"韩伟",
                position:"乐刻运动创始人兼CEO"
            },{
                img:"http://static-image.xfz.cn/1503035698_83.jpg-course.list.small",
                url:"http://www.xfz.cn/course/145.html",
                title:"洞察新未来——音乐教育行业的一元复始",
                name:"张桐",
                position:"Finger创始人兼CEO"
            }],
        }
    },
    methods:{
        addListenScroll(){
            var self = this
            window.onscroll = function (e) {
                var h_scrolled = document.body.scrollTop;
                // top nav
                if(h_scrolled > 500 ){
                   self.showNav = false;
                } else {
                   self.showNav = true;
                }
            }
        },
        getNewsListFake(){
            this.newsData = this.newDataFake.data
        },
        getNewsList() {

            var self = this
            util.resource({
                url: '/api/website/articles/?tag=2019小饭桌全球青年创业者大会&n=1000&p=1',
                method: 'get',
                success (res) {
                    if (res.code == 200) {
                        self.newsData = res.data
                    }
                }
            })
        },
        refreshContent(){
            this.newsData = []
            this.getNewsList()
        }
    },
    mounted(){
        this.liveData = liveData
        this.addListenScroll()
        this.getNewsList()
        // this.getNewsListFake()
        util.getWx()
    }
}
</script>
<style lang="scss">
#pc-news {
    font-size: 14px;
    min-width: 1200px;
    min-height: 200px;
    // background-image: url(http://static-image.xfz.cn/explore/2017cusc/bg-dot.png);
    background: linear-gradient(to right ,#304fff, #2d6eff);
    .header-wrap{
        height: 700px;
        // background-image: url('../assets/2019/pc-banner.jpg');
        background: {
            image: url('../assets/2019/pc-banner.jpg');
            repeat: no-repeat;
            position: center;
        }
        .menu-logo {
            float: left;
            width: 160px;
            margin-top: 8px;
        }
        .nav{
            position: fixed;
            top: 0;
            left: 0;
            z-index: 3;
            right: 0;
            text-align: right;
            background-image: -webkit-linear-gradient(right,rgba(255,222,212,.2) 30%,#2b4df3e3 50%),-webkit-linear-gradient(#39a3fa7d,#39a3fa7d);
            background-image: linear-gradient(-90deg,rgba(255,222,212,.2) 30%,#2b4df3e3 50%),linear-gradient(#39a3fa7d,#39a3fa7d);
            line-height: 50px;
            ul {
                width: 1170px;
                margin: 0 auto;
                display: block;
                li {
                    cursor: pointer;
                    font-weight: bold;
                    font-size: 18px;
                    display: inline-block;
                    list-style: none;
                    padding: 0 10px;
                    color: #fff;
                    a {
                        text-decoration: none;
                        color: #fff;
                    }
                    &:hover {
                        a{
                            color: #fff;
                            border-bottom: 4px solid #ff9671;
                            padding-bottom: 11px;
                            color: #fff;
                        }
                    }
                }
                .active{
                    background-color: #0079cf;
                }
            }
        }
        .logo{
            padding-top:90px;
            max-width: 200px;
            margin: 0 auto;
            margin-bottom: 90px;
            img{
                width: 216px;
            }
        }
        .conf-name{
            width: 100%;
            text-align: center;
            color: #fff;
            .name-main{
                font-size: 76px;
                font-weight: bold;
                margin-bottom: 5px;
            }
            .name-sub{
                font-size: 38px;
                margin-bottom: 90px;
            }
            .hotel{
                font-size: 24px;
            }
        }
    }
    .live{
        margin-top: 30px;
        margin-bottom: 100px;
        .live-wrap{
            width: 1170px;
            margin: 0 auto;
            .live-items-wrap{
                text-align:center;
                margin-bottom : 20px;
            }
        }
        .live-title{
            font-size: 38px;
            color: #ffc485;
            width: 1150px;
            padding-left: 80px;
            padding-top: 10px;
        }
        .live-area {
            margin: 20px;
            text-align: left;
            img {
                max-height: 66px;
            }
        }
        .date-title{
            width: 1150px;
            margin: 0 auto;
            text-align: left;
            font-size: 24px;
            color:#0047ca;
            margin-top:10px;
        }
        .live-item{
            display: inline-block;
            margin: 10px 10px;
            width: 260px;
            text-align: center;
            // border: 2px solid #1a74bf;
            .live-name{
                font-size: 24px;
                color: #0047ca;
                padding:6px;
                background-color: #1a74bf;
                a{
                    font-weight: bold;
                    text-decoration: none;
                    color: #fff;
                }
            }
            .live-links{
                // background-color: #0047ca;
                background-color: #fff;
                a{
                    text-decoration: none;
                    color: #1a74bf;
                }
                .link-item{
                    font-size: 22px;
                    font-weight: bold;
                    display: inline-block;
                    color: #fff;
                    padding: 4px 20px;
                }
                .link-divider{
                    display: inline-block;
                    font-size: 19px;
                    width: 2px;
                    color: #1a74bf;
                    background-color: #1a74bf;
                }
            }
        }
    }
    .course{
        margin-top: 30px;
        margin-bottom: 30px;
        .course-wrap{
            width: 1170px;
            margin: 0 auto;
            padding-bottom:10px;
            background:#f2f2f2;
            .course-items-wrap{
                text-align:center;
                margin-bottom:20px;
            }
            &:nth-child(2){
                margin-top:20px;
            }
        }
        .course-title{
            font-size: 46px;
            color: #042745;
            width: 1150px;
            padding-left: 40px;
            padding-top: 15px;
        }
        .course-area{
            display:block;
            overflow:hidden;
            margin: 20px 25px;

        }
        .date-title{
            width: 1150px;
            margin: 0 auto;
            text-align: left;
            font-size: 24px;
            color:#0047ca;
            margin-top:10px;
        }
        &:nth-child(2){
            .course-item {
                margin-bottom:20px;
            }
        }
        .course-item{
            float:left;
            margin: 0 10px;
            width: 260px;
            a {
                text-decoration:none;
            }
            .info-price {
                font-size: 20px;
                color: #f54a4a;
                span {
                    font-size: 14px;
                    margin-right: 5px;
                }
                &.free {
                    color: #7ed321;
                }
            }
            .info-start {
                &.course {
                    color: #00caa9;
                }
                &.replay {
                    color: #f5a623;
                }
            }
            &:hover {
                box-shadow: 0 4px 8px rgba(0, 0, 0, .1);
            }
            .info-logo {
                max-height: 146px;
                overflow: hidden;
                position: relative;
                .tags {
                    display:inline-block;
                    width:50px;
                    height:50px;
                    position: absolute;
                    top:50%;
                    left:50%;
                    margin-top:-25px;
                    margin-left:-25px;
                    /* background:url("http://www.xfz.cn/static/build/images/video-tag.png");*/
                    background:url("http://static-image.xfz.cn/player-latest-icon.png")
                }
                img {
                    width: 100%;
                }
            }
            .info-content {
                box-sizing: border-box;
                padding: 15px;
                background: #fff;
                .course-item-title {
                    font-size: 16px;
                    text-align:left;
                    color:rgb(105,105,105);
                    line-height: 26px;
                    height: 62px;
                    overflow: hidden;
                }
                .info-author {
                    text-align:left;
                    line-height: 34px;
                    font-size: 14px;
                    color: #9b9b9b;
                    height: 34px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
                .info-start {
                    position: absolute;
                    bottom: 15px;
                    font-size: 13px;
                    &.not-start {
                        color: #9b9b9b;
                    }
                }
                .info-series-num,
                .info-time {
                    position: absolute;
                    bottom: 37px;
                    font-size: 14px;
                }
                .info-haspay,
                .info-series-price,
                .info-price {
                    text-align: right;
                    right:10px;
                    position: absolute;
                    line-height: 30px;
                    bottom: 10px;
                }
            }
        }
    }
    .pc-news-list{
        .news-list-wrap{
            width: 1170px;
            margin: 0 auto;
            background-color: #fff;
            padding: 20px;
            .title-area{
                width: 1100px;
                margin: 20px auto;
                color: #042745;
                .title{
                    display: inline-block;
                    font-size: 46px;
                }
                .refresh{
                    font-size: 20px;
                    float: right;
                    cursor: pointer;
                    height: 70px;
                    line-height: 70px;
                    img {
                        display: inline-block;
                        width: 16px;
                    }
                }
            }

        }
    }
}
</style>



// WEBPACK FOOTER //
// PcNews.vue?40ae00b4